<ng-container *transloco="let t">
  <tui-textfield multi tuiChevron [stringify]="stringify">
    <input
      ngDefaultControl
      tuiInputChip
      tuiSelectLike
      [ngModel]="value"
      [placeholder]="value?.length ? '' : t('Aucun groupe sélectionné')"
      (ngModelChange)="selectDepartments($event)" />
    <tui-input-chip *tuiItem />
    <tui-data-list *tuiDropdown>
      <tui-opt-group tuiMultiSelectGroup [label]="t('Données collaboratives')">
        @for (department of departments | tuiFilterByInput; track department.id) {
          <button tuiOption type="button" [value]="department">
            {{ department.name }}
          </button>
        }
      </tui-opt-group>
    </tui-data-list>
  </tui-textfield>
</ng-container>
